import { render, staticRenderFns } from "./AdminPasswordValidatorSettings.vue?vue&type=template&id=38db8f9a&"
import script from "./AdminPasswordValidatorSettings.vue?vue&type=script&lang=ts&"
export * from "./AdminPasswordValidatorSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports